import { useEffect } from 'react';

let locks = 0;

/** Locks page scroll while at least one overlay is open. */
export function useBodyScrollLock(active: boolean) {
  useEffect(() => {
    if (!active) return;
    locks += 1;
    const { body } = document;
    const prev = body.style.overflow;
    body.style.overflow = 'hidden';
    return () => {
      locks -= 1;
      if (locks === 0) body.style.overflow = prev;
    };
  }, [active]);
}
